export const categories = [
  {
    id: 1,
    name: "Ladies Boutique Collection",
    label: "Ladies' Wear",
    tag: 'Best Seller',
    image: 'https://images.pexels.com/photos/21897142/pexels-photo-21897142.jpeg',
    moq: '50 Pieces',
  },
  {
    id: 2,
    name: "Men's Wholesale Collection",
    label: "Men's Wear",
    tag: 'Bulk Available',
    image: 'https://images.unsplash.com/photo-1611312449408-fcece27cdbb7?w=600&q=80',
    moq: '50 Pieces',
  },
  {
    id: 3,
    name: "Kids Bulk Collection",
    label: "Kids' Wear",
    tag: 'Bulk Available',
    image: 'https://images.unsplash.com/photo-1627639679638-8485316a4b21?w=600&q=80',
    moq: '100 Pieces',
  },
  {
    id: 4,
    name: "Saree Collection",
    label: "Saree",
    tag: 'Bulk Available',
    image: 'https://images.pexels.com/photos/28943484/pexels-photo-28943484.jpeg',
    moq: '25 Pieces',
  },
  {
    id: 5,
    name: 'Ethnic Collection',
    label: 'Ethnic Wear',
    tag: 'New Arrival',
    image: 'https://images.pexels.com/photos/33959044/pexels-photo-33959044.jpeg?auto=compress&cs=tinysrgb&w=600',
    moq: '25 Pieces',
  },
  {
    id: 6,
    name: 'Blanket Collection',
    label: "Blanket",
    tag: 'Winter Special',
    image: 'https://images.pexels.com/photos/31542019/pexels-photo-31542019.jpeg',
    moq: '20 Pieces',
  },
];

export const products = [
  // 1. Ladies' Wear
  {
    id: 1,
    sku: 'LDS-2026-001',
    collection: 'Summer Florals',
    category: "Ladies' Wear",
    badge: 'Best Seller',
    image: '/ladies_1.png',
  },
  {
    id: 101,
    sku: 'LDS-2026-002',
    collection: 'Boutique Fusion',
    category: "Ladies' Wear",
    badge: 'New Arrival',
    image: '/ladies_2.png',
  },
  {
    id: 102,
    sku: 'LDS-2026-003',
    collection: 'Cotton Comfort',
    category: "Ladies' Wear",
    badge: 'Bulk available',
    image: '/ladies_3.png',
  },
  {
    id: 103,
    sku: 'LDS-2026-004',
    collection: 'Designer Kurtis',
    category: "Ladies' Wear",
    badge: 'Hot Choice',
    image: '/ladies_4.png',
  },
  {
    id: 104,
    sku: 'LDS-2026-005',
    collection: 'Festive Special',
    category: "Ladies' Wear",
    badge: 'Trending',
    image: '/ladies_5.png',
  },
  {
    id: 105,
    sku: 'LDS-2026-006',
    collection: 'Casual Denim',
    category: "Ladies' Wear",
    badge: 'Popular',
    image: '/ladies_6.png',
  },
  {
    id: 106,
    sku: 'LDS-2026-007',
    collection: 'Couple Couture',
    category: "Ladies' Wear",
    badge: 'Premium Match',
    image: '/ladies_7.png',
  },

  // 2. Men's Wear
  {
    id: 2,
    sku: 'MEN-2026-001',
    collection: 'Casual Everyday',
    category: "Men's Wear",
    badge: 'New Arrival',
    image: '/men_1.png',
  },
  {
    id: 201,
    sku: 'MEN-2026-002',
    collection: 'Linen Collection',
    category: "Men's Wear",
    badge: 'Premium',
    image: '/men_2.png',
  },
  {
    id: 202,
    sku: 'MEN-2026-003',
    collection: 'Office Formal',
    category: "Men's Wear",
    badge: 'Best Seller',
    image: '/men_3.png',
  },
  {
    id: 203,
    sku: 'MEN-2026-004',
    collection: 'Denim Series',
    category: "Men's Wear",
    badge: 'Hot',
    image: '/men_4.png',
  },
  {
    id: 204,
    sku: 'MEN-2026-005',
    collection: 'Weekend Vibes',
    category: "Men's Wear",
    badge: 'Bulk Price',
    image: '/men_5.png',
  },

  // 3. Kids' Wear
  {
    id: 4,
    sku: 'KDS-2026-001',
    collection: 'Young Trendsetter',
    category: "Kids' Wear",
    badge: 'Bulk Available',
    image: '/kids_1.png',
  },
  {
    id: 301,
    sku: 'KDS-2026-002',
    collection: 'Playful Prints',
    category: "Kids' Wear",
    badge: 'New Arrival',
    image: '/kids_2.png',
  },
  {
    id: 302,
    sku: 'KDS-2026-003',
    collection: 'Little Explorer',
    category: "Kids' Wear",
    badge: 'Best Offer',
    image: '/kids_3.png',
  },
  {
    id: 303,
    sku: 'KDS-2026-004',
    collection: 'Holiday Wear',
    category: "Kids' Wear",
    badge: 'Trending',
    image: '/kids_4.png',
  },
  {
    id: 304,
    sku: 'KDS-2026-005',
    collection: 'Smart Casuals',
    category: "Kids' Wear",
    badge: 'Hot Seller',
    image: '/kids_5.png',
  },

  // 4. Saree / Evening Wear
  {
    id: 3,
    sku: 'SARE-2026-001',
    collection: 'Silk Kanjivaram',
    category: "Saree",
    badge: 'Elite',
    image: '/saree_1.png',
  },
  {
    id: 401,
    sku: 'SARE-2026-002',
    collection: 'Banarasi Weave',
    category: "Saree",
    badge: 'Bulk Available',
    image: '/saree_2.png',
  },
  {
    id: 402,
    sku: 'SARE-2026-003',
    collection: 'Chiffon Elegance',
    category: "Saree",
    badge: 'Best Seller',
    image: '/saree_3.png',
  },
  {
    id: 403,
    sku: 'SARE-2026-004',
    collection: 'Cotton Daily',
    category: "Saree",
    badge: 'Value Pack',
    image: '/ethnic_6.png',
  },
  {
    id: 404,
    sku: 'SARE-2026-005',
    collection: 'Zari Border',
    category: "Saree",
    badge: 'Hot Choice',
    image: '/ethnic_7.png',
  },

  // 5. Blanket
  {
    id: 5,
    sku: 'BLK-2026-001',
    collection: 'Plush Comfort',
    category: "Blanket",
    badge: 'Winter King',
    image: '/blanket_1.png',
  },
  {
    id: 501,
    sku: 'BLK-2026-002',
    collection: 'Velvet Soft',
    category: "Blanket",
    badge: 'Premium',
    image: '/blanket_2.png',
  },
  {
    id: 502,
    sku: 'BLK-2026-003',
    collection: 'Dual Sided',
    category: "Blanket",
    badge: 'Hot Seller',
    image: '/blanket_3.png',
  },
  {
    id: 503,
    sku: 'BLK-2026-004',
    collection: 'Fleece Warmth',
    category: "Blanket",
    badge: 'Bulk Price',
    image: '/blanket_4.png',
  },
  {
    id: 504,
    sku: 'BLK-2026-005',
    collection: 'Luxury Mink',
    category: "Blanket",
    badge: 'Trending',
    image: '/blanket_5.png',
  },

  // 6. Ethnic Wear
  {
    id: 6,
    sku: 'ETH-2026-001',
    collection: 'Festive Ethnic',
    category: 'Ethnic Wear',
    badge: 'New Style',
    image: '/ethnic_1.png',
  },
  {
    id: 601,
    sku: 'ETH-2026-002',
    collection: 'Traditional Lehnga',
    category: 'Ethnic Wear',
    badge: 'Bulk Only',
    image: '/ethnic_2.png',
  },
  {
    id: 602,
    sku: 'ETH-2026-003',
    collection: 'Designer Anarkali',
    category: 'Ethnic Wear',
    badge: 'Trending',
    image: '/ethnic_3.png',
  },
  {
    id: 603,
    sku: 'ETH-2026-004',
    collection: 'Wedding Gallery',
    category: 'Ethnic Wear',
    badge: 'Hot',
    image: '/ethnic_4.png',
  },
  {
    id: 604,
    sku: 'ETH-2026-005',
    collection: 'Ceremonial Silk',
    category: 'Ethnic Wear',
    badge: 'Premium',
    image: '/ethnic_5.png',
  },
];

export const testimonials = [
  {
    id: 1,
    rating: 5,
    review: "The quality of the Rayon and Cotton fabrics is exceptional. We've been sourcing for our Ahmedabad showrooms for 2 years. Their 24-hour dispatch is a lifesaver during festive seasons.",
    name: 'Anjali Verma',
    role: 'Showroom Owner, Ahmedabad',
    avatar: 'https://ui-avatars.com/api/?name=Anjali+Verma&background=C9A14A&color=fff&bold=true',
  },
  {
    id: 2,
    rating: 5,
    review: "Switching to Anapurna Sales helped us improve our retail margins by 20%. Factory-direct pricing without the hassle of middlemen. Their WhatsApp support for bulk orders is very responsive.",
    name: 'Rajesh Khanna',
    role: 'Wholesale Dealer, Surat',
    avatar: 'https://ui-avatars.com/api/?name=Rajesh+Khanna&background=0B0F19&color=fff&bold=true',
  },
  {
    id: 3,
    rating: 5,
    review: "Highly trend-driven collections. The MOQ of 50 pieces allows us to test new styles across our retail chain before committing to larger inventories. On-time delivery every single time.",
    name: 'Manoj Singhania',
    role: 'Retail Chain Manager, Indore',
    avatar: 'https://ui-avatars.com/api/?name=Manoj+Singhania&background=C9A14A&color=fff&bold=true',
  },
  {
    id: 4,
    rating: 5,
    review: "As a boutique owner in Kerala, I was worried about shipping times, but Anapurna's logistics partners are incredibly reliable. The packaging is always secure and professional.",
    name: 'Lakshmi Menon',
    role: 'Boutique Owner, Kochi',
    avatar: 'https://ui-avatars.com/api/?name=Lakshmi+Menon&background=0B0F19&color=fff&bold=true',
  },
  {
    id: 5,
    rating: 5,
    review: "The variety of ethnic wear is unmatched. We sourcing for over 5 outlets and the consistency in fabric quality across bulk batches is what keeps us coming back.",
    name: 'Vikram Seth',
    role: 'Director, Ethnic Hub',
    avatar: 'https://ui-avatars.com/api/?name=Vikram+Seth&background=C9A14A&color=fff&bold=true',
  },
  {
    id: 6,
    rating: 5,
    review: "Their digital catalogue is a game changer for resellers. I can show designs to my clients before even placing my bulk order. Transparency in pricing is a big plus.",
    name: 'Deepika Rao',
    role: 'Independent Reseller, Mumbai',
    avatar: 'https://ui-avatars.com/api/?name=Deepika+Rao&background=0B0F19&color=fff&bold=true',
  },
  {
    id: 7,
    rating: 5,
    review: "Great experience with their dedicated account manager. They helped us curate a collection specifically for our local market's taste. Highly personalized service for B2B.",
    name: 'Suresh Bhatia',
    role: 'Owner, Bhatia Garments',
    avatar: 'https://ui-avatars.com/api/?name=Suresh+Bhatia&background=C9A14A&color=fff&bold=true',
  },
  {
    id: 8,
    rating: 5,
    review: "For anyone looking to scale their clothing business, Anapurna is the right partner. Their bulk availability and inventory depth are superior to what we found in local markets.",
    name: 'Rahul Dua',
    role: 'Operations Head, Fashion Ltd',
    avatar: 'https://ui-avatars.com/api/?name=Rahul+Dua&background=0B0F19&color=fff&bold=true',
  },
];

export const galleryImages = [
  {
    id: 1,
    image: 'https://images.pexels.com/photos/25987916/pexels-photo-25987916.jpeg?auto=compress&cs=tinysrgb&w=500',
    alt: 'Wholesale fashion collection 1',
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1539684371066-9079b087853b?w=500&q=80',
    alt: 'Wholesale fashion collection 2',
  },
  {
    id: 3,
    image: 'https://images.pexels.com/photos/7324786/pexels-photo-7324786.jpeg?auto=compress&cs=tinysrgb&w=500',
    alt: 'Wholesale fashion collection 3',
  },
  {
    id: 4,
    image: 'https://images.pexels.com/photos/29242228/pexels-photo-29242228.jpeg?auto=compress&cs=tinysrgb&w=500',
    alt: 'Wholesale fashion collection 4',
  },
];

export const valuePropositions = [
  {
    id: 1,
    icon: 'Factory',
    title: 'Factory Direct Pricing',
    description: 'Source directly from manufacturers — no middlemen. Maximize your margins.',
  },
  {
    id: 2,
    icon: 'TrendingUp',
    title: 'Latest Trending Designs',
    description: 'New collections every season. Stock what sells — backed by retail trend data.',
  },
  {
    id: 3,
    icon: 'Package',
    title: 'Low Minimum Order',
    description: 'Start from just 50 pieces per style. Scale as your business grows.',
  },
  {
    id: 4,
    icon: 'Truck',
    title: 'Pan India Fast Delivery',
    description: 'Reliable logistics network. Orders dispatched within 24–48 hours.',
  },
  {
    id: 5,
    icon: 'Headphones',
    title: 'Dedicated B2B Support',
    description: 'Personal account manager for your business. WhatsApp & phone support.',
  },
  {
    id: 6,
    icon: 'ShieldCheck',
    title: 'Quality Guaranteed',
    description: 'Every piece quality-checked before dispatch. Trusted by 500+ retailers.',
  },
];
